import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { generatePath, useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';

import { isApiQueryError, usePostProductsMutation } from '@client/api';
import { Skeleton } from '@client/toolkit';

import { ProductsPaths } from '../products.router';

export function ProductCreateRoute() {
  const { t } = useTranslation('products');
  const { t: tCommon } = useTranslation();
  const { t: tValidation } = useTranslation('validation');
  const navigate = useNavigate();

  const [mutation, { isLoading }] = usePostProductsMutation();
  const createdRef = useRef(false);

  useEffect(() => {
    if (createdRef.current) return;
    createdRef.current = true;

    const createDraft = async () => {
      try {
        const result = await mutation({
          body: {
            name: t('productCreate.draftName'),
            category: 'Other',
            unit: { scheme: 'AreaMetric' },
            prices: [
              {
                unitAmount: { amount: 0, currency: { code: 'NOK' } },
                interval: { count: 1, type: 'Month' },
              },
            ],
          },
        }).unwrap();

        navigate(generatePath(ProductsPaths.Product, { id: result.id }), { replace: true, state: { isNew: true } });
      } catch (e: unknown) {
        if (isApiQueryError(e) && e.status === 400) {
          toast.error(tValidation(`server.${e.data.detail}`), { id: 'global-error' });
        }
        navigate(generatePath(ProductsPaths.Products), { replace: true });
      }
    };

    createDraft();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="flex items-center justify-center p-12">
      <Skeleton variant="text" className="w-48" />
    </div>
  );
}
